export const POST_OFFICE = 'post-office'
export const YOTI_WITH_POST_OFFICE = 'yoti-with-post-office'
export const YOTI = 'yoti'
export const DIDC = 'didc'
